var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quad__block__child learn__more"},[(_vm.category)?_c('h4',{domProps:{"innerHTML":_vm._s(_vm.category)}}):_vm._e(),_vm._v(" "),(_vm.title)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.description)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._v(" "),(_vm.link)?_c('a',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.link_label)+" →")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib?{}!./scripts/vue/LearnMore.vue?vue&type=template&id=79cd3331&scoped=true&
// module id = 245
// module chunks = 0